import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DeviceReset } from '../device-reset.model';
import { DeviceResetActions, DeviceResetActionTypes } from '../actions/device-reset.actions';

export interface State extends EntityState<DeviceReset> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<DeviceReset> = createEntityAdapter<DeviceReset>();

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false,
});

export interface DeviceResetLogState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialDeviceResetLogState: DeviceResetLogState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: DeviceResetActions
): State {
  switch (action.type) {
    case DeviceResetActionTypes.AddDeviceReset: {
      return adapter.addOne(action.payload.deviceReset, state);
    }

    case DeviceResetActionTypes.UpsertDeviceReset: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case DeviceResetActionTypes.AddDeviceResets: {
      return adapter.addMany(action.payload.deviceResets, state);
    }

    case DeviceResetActionTypes.UpsertDeviceResets: {
      return adapter.upsertMany(action.payload.deviceResets, state);
    }

    case DeviceResetActionTypes.UpdateDeviceReset: {
      return adapter.updateOne(action.payload.deviceReset, state);
    }

    case DeviceResetActionTypes.UpdateDeviceResets: {
      return adapter.updateMany(action.payload.deviceResets, state);
    }

    case DeviceResetActionTypes.DeleteDeviceReset: {
      return adapter.removeOne(action.payload.id, state);
    }

    case DeviceResetActionTypes.DeleteDeviceResets: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DeviceResetActionTypes.LoadDeviceResets: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceResetActionTypes.ClearDeviceResets: {
      return adapter.removeAll(state);
    }

    case DeviceResetActionTypes.DeviceResetsFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export function deviceResetLogreducer(
  state: DeviceResetLogState = initialDeviceResetLogState, action: DeviceResetActions
): DeviceResetLogState {
  switch (action.type) {

    case DeviceResetActionTypes.GetResetDeviceLog: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceResetActionTypes.GetResetDeviceLogFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case DeviceResetActionTypes.GetResetDeviceLogSuccess: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getDeviceResetLogState = (state: DeviceResetLogState) => state;
